module.exports = __webpack_public_path__ + "img/cep.dc57f137.svg";